<div class="c-page-saa">
    <div class="container u-pb30"> 
        <p style="font-family: Arial, Helvetica, sans-serif; font-size:16px; color:#252525; text-align:left; padding-top:20px; line-height: 20px;">{{ 'MedicalTestPublic.labelInfo' | translate}}:</p>
      <div class="row u-pt30"> 
        
        <div class="col-md-12" style="padding: 5px !important;"> 
            <h2 class="o-title o-title--medium o-title--orange">{{ 'MedicalTestPublic.titleRequestDetail' | translate}} </h2>     
        </div>
        <div class="col-md-12">
          <div class="c-card c-card--detail"> 
            <div class="row"> 
              <div class="col-md-2"><strong >{{ 'MedicalTestPublic.labelSite' | translate}}:</strong>
                <p>{{request.site}}</p>
              </div>
              <div class="col-md-2"><strong >{{ 'MedicalTestPublic.labelZone' | translate}}:</strong>
                <p>{{request.zone}}</p>
              </div>
              <div class="col-md-2" *ngIf="request.subZone != ''">
                <strong class="js-txt19">{{ 'MedicalTestPublic.labelSubzone' | translate}}:</strong>
                <p>{{request.subZone}}</p>
              </div>
              <div class="col-md-2"><strong >{{ 'MedicalTestPublic.labelFrom' | translate}}:</strong>
                <p>{{request.from | date: 'dd/MM/yyyy'}} </p>
              </div>
              <div class="col-md-2"><strong >{{ 'MedicalTestPublic.labelTo' | translate}}:</strong>
                <p>{{request.to | date: 'dd/MM/yyyy'}}</p>
              </div>
              <br>
              <div class="col-md-12" style="padding-top: 10px;"><strong >{{ 'MedicalTestPublic.purpose' | translate}}:</strong>
                <p >{{request.purpuse}}</p>
              </div>
            </div>
          </div>
          <hr class="big">
        </div>

        <div class="col-md-12"> 
          <h2 class="o-title o-title--medium o-title--orange">{{ 'MedicalTestPublic.applicantInformation' | translate}}</h2>
        </div>
        
        <div class="col-md-12"> 
          <div class="o-etable">
            <div class="o-etable__employee">
              <div class="row">
                
                <div class="col-md-2 col-xs-10">
                    <p class="u-hide__desktop"><strong >{{ 'MedicalTestPublic.labelRUT' | translate}}</strong></p>
                  </div>
                  <div class="col-md-2 col-xs-10">
                    <p class="u-hide__desktop"><strong >{{ 'MedicalTestPublic.labelPassport' | translate}}</strong></p>
                  </div>
                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                  <p class="u-hide__desktop"><strong >{{ 'MedicalTestPublic.labelName' | translate}}</strong></p>
                </div>
                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                    <p class="u-hide__desktop"><strong>{{ 'MedicalTestPublic.labelNationatily' | translate}}</strong></p>
                  </div>
                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                  <p class="u-hide__desktop"><strong>{{ 'MedicalTestPublic.labelEmail' | translate}}</strong></p>
                </div>
              </div>
            </div>
            <div class="o-etable--body" >
              <div class="o-etable__employee o-etable__employee--approved" >
                <div class="row" >
                  <div class="col-md-2 col-xs-10">
                    <p>
                      <span class="u-show__mobile">{{ 'MedicalTestPublic.labelRUT' | translate}} </span>
                        <span> 
                          <p class="green" *ngIf="people.nationalId !=''">
                            {{people.nationalId}}
                          </p>
                          <p  *ngIf="people.nationalId===''">
                            -
                          </p>
                        </span>
                      </p>
                   
                  </div>
                  <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                    <p class="green" *ngIf="people.passportNumber">
                        {{people.passportNumber}}
                      </p>
                      <p class="green" *ngIf="!people.passportNumber">
                        -
                      </p>
                  </div>
                  <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                    <p>{{people.firstName}}</p>
                  </div>
                  <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                    <p>{{people.nationality}}</p>
                  </div>
                  <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                    <p>{{people.email}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 u-pt50" style="text-align: center;">
              <button class="btn btn btn--primary" (click)="onSubmit(3)">{{ 'MedicalTestPublic.statusReject' | translate}}</button>
              <button class="btn btn--primary " (click)="onSubmit(2)" >{{ 'MedicalTestPublic.statusApproved' | translate}} </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


